import { IUser } from "@models/user.model";
import {
  doc,
  collection,
  getFirestore,
  DocumentReference,
} from "firebase/firestore";

export const getUserCollectionRef = () => collection(getFirestore(), "users");
export const getUserDocRef = (uid: string) =>
  doc(getUserCollectionRef(), uid) as DocumentReference<IUser>;
